/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import {
  BackgroundIcon,
  getTranslatedText,
  COLOR_MAP,
  DateTimeFormatter,
  useUserMSPCheckHook,
  Splitter,
  ChatThreadContainer
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import Recepients from '@nile/mangifera/src/Components/Chat/Recepients';
import { Avatar } from '@superops/ui-design-system';
import Collapse from 'react-collapse';
import React, { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Tooltip } from 'react-tippy';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';

const ThreadWrapper = styled.div`
  height: auto;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  ${(props) => props.isOpen && `height: 100%;`}

  ${(props) => props.isOpen && `height: 100%;`}

  .ReactCollapse--collapse {
    height: ${(props) =>
      props.isOpen
        ? `calc(100% - ${props.headerHeight || 77}px) !important`
        : ''};
    transition: height 150ms linear;
  }
  .ReactCollapse--content {
    height: ${(props) => (props.isOpen ? '100% !important' : '')};
  }
`;

const Thread = styled.div`
  background: var(--sops-white-to-grey-bg);
  padding: 12px 14px 12px 25px;
  border-radius: 10px;
  ${(props) =>
    props.isOpen &&
    `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}
  .subject {
    color: #0b0114;
    font-size: 20px;
    line-height: 30px;
    font-weight: 400;
    opacity: 0.6;
    max-width: calc(100% - 140px);
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // overflow: hidden;

    &.unopened {
      font-weight: 600;
      opacity: 1;
    }
  }
  .to-user,
  .date {
    color: #000000;
    opacity: 80%;
    font-size: 12px;
    line-height: 18px;
  }
  cursor: pointer;
  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.05);
`;

const Item = styled.div`
  height: 24px;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  align-items: center;
  background: #f2f5ff;
  border-radius: 12px;
  padding: 2px 8px 2px 1px;
`;

function ChatThreads(props) {
  const {
    intl,
    isOpened,
    conversation,
    containerRef,
    modalOnly,
    toggleNewSideConversation
  } = props;
  const isMSP = useUserMSPCheckHook();
  const [isOpen, setIsOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(77);

  const ThreadRef = useRef(conversation.conversationId);
  const HeaderRef = useRef(conversation.conversationId);

  const ScrollIntoView = () => {
    const container = containerRef.current?.getBoundingClientRect();
    const ThreadRefRect = ThreadRef?.current?.getBoundingClientRect();
    const { top, bottom } = ThreadRefRect;
    if (!(top >= 0 && bottom <= container?.bottom && top >= container?.top)) {
      setTimeout(() => {
        ThreadRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 1000);
    }
  };

  const toggleThread = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpened) {
      setIsOpen(true);
    }
  }, [isOpened]);

  useEffect(() => {
    if (isOpen && ThreadRef.current) {
      ScrollIntoView();
      setHeaderHeight(HeaderRef.current?.getBoundingClientRect()?.height);
    }
  }, [isOpen]);

  const allToUsers = conversation.toUsers || [];
  const allCCUsers = conversation.ccUsers || [];
  const isNotRead =
    conversation.latestReply.type === 'VENDOR_EMAIL' && !conversation.opened;

  return (
    <ThreadWrapper ref={ThreadRef} isOpen={isOpen} headerHeight={headerHeight}>
      <Thread
        className="flex"
        ref={HeaderRef}
        onClick={toggleThread}
        isOpen={isOpen}
      >
        <div className="grid fg1">
          <div className="fx">
            <div
              className={`subject ${isNotRead ? 'unopened' : ''}`}
              title={conversation.subject}
            >
              {conversation.subject}
            </div>
            <div className="mlauto mt-8">
              <SVGIcon
                name={isOpen ? 'ArrowDown' : 'ArrowRight'}
                color={COLOR_MAP.black}
              />
            </div>
          </div>
          <div className="to-user fx actr">
            <div className="date">
              <DateTimeFormatter
                relative
                type="dateTime"
                date={conversation.time}
              />
            </div>
            {allToUsers && allToUsers.length ? (
              <>
                <Splitter className="ml-5" color={COLOR_MAP.grey} />

                <Item className="d-in-f ml-5">
                  <Avatar
                    name={allToUsers[0].user.email}
                    initials={allToUsers[0].user.email[0]}
                    size="extraSmall"
                  />
                  <div className="ml-5">{allToUsers[0].user.email}</div>
                </Item>
                {allToUsers.length > 1 || allCCUsers.length ? (
                  <div className="ml8">
                    <Tooltip
                      html={
                        <Recepients
                          bubbleContainer
                          message={{ ...conversation, bccUsers: [] }}
                        />
                      }
                      delay={300}
                      duration={250}
                      position="bottom-start"
                      inertia
                      trigger="mouseenter"
                      animation="shift"
                      animateFill={false}
                      theme="super-light"
                    >
                      <div className="flex center">
                        <SVGIcon name="DropSheet" size="sm" />
                      </div>
                    </Tooltip>
                  </div>
                ) : null}
              </>
            ) : null}
            {isNotRead && (
              <span className="fx jend ml8 fg1">
                <Tooltip
                  inertia
                  delay={300}
                  theme="dark"
                  duration={250}
                  animation="shift"
                  animateFill={false}
                  trigger="mouseenter"
                  position="bottom-start"
                  html={getTranslatedText(
                    intl,
                    'vendor.replied.ticket.onhover.tooltip'
                  )}
                >
                  <SVGIcon name="Helpcenter" color="#ff4c88" />
                </Tooltip>
              </span>
            )}
          </div>
        </div>
      </Thread>
      <Collapse isOpened={isOpen}>
        <ChatThreadContainer
          currentReplyThread={conversation}
          isMSP={isMSP}
          modalOnly={modalOnly}
          toggleNewSideConversation={toggleNewSideConversation}
          {...props}
        />
      </Collapse>
    </ThreadWrapper>
  );
}

export { ChatThreadContainer } from './ChatThreadContainer';
export default injectIntl(ChatThreads);
